<template lang="html">
  <div :class="'siline '+ className">

    <div :class="'info_startup '+ className">
      <div class="info_startup_1">

            <span :class="'info_name '+color_info">{{name.replaceAll("_"," ")}}</span>
      </div>
      <div class="info_startup_2" v-if="noData == true">
          <span class="info_value" >No data</span>
      </div>
      <div class="info_startup_2" v-else-if="isLocation == true">
        <span v-if="value.length == 0 || value == null">No data</span>
          <span class="info_value" v-else v-for="(val, v) in value" :key="v">
            <span v-if="val">
              <span v-if="val.name"> {{ $t(val.name)}}</span>
                <span v-else>{{$t(val)}}</span>
              <span v-if="v < value.length - 1" class="pointmediant"></span>
            </span>
            <span v-else>No data</span>
          </span>
      </div>
      <div class="info_startup_2" v-else-if="isArray == true">
        <span v-if="value.length == 0 || value == null">No data</span>
          <span class="info_value" v-else v-for="(val, v) in value" :key="v">
            <span v-if="val">
              <span v-if="val.name"> {{val.name}}</span>
                <span v-else>{{val}}</span>
              <span v-if="v < value.length - 1" class="pointmediant"></span>
            </span>
            <span v-else>No data</span>
          </span>
      </div>
      <div class="info_startup_2" v-else-if="isCurrency">

        <span v-if="typeof value.value !== 'undefined' ">
          <span class="info_value" v-if="Number.isInteger(value.value)" >{{parseInt(value.value)}}<span>&nbsp;{{value.unit}}</span>&nbsp;<span>{{value.currency}}</span></span>

          <span class="info_value" v-else-if="value.value >= 0.1" >{{prettyPrintMoney(value.value,1)}}<span>&nbsp;{{value.unit}}</span>&nbsp;<span>{{value.currency}}</span></span>
          <span class="info_value" v-else-if="value.value >= 0.01" >{{prettyPrintMoney(value.value,2)}}<span>&nbsp;{{value.unit}}</span>&nbsp;<span>{{value.currency}}</span></span>
          <span class="info_value" v-else-if="value.value != 0" >{{prettyPrintMoney(value.value,3)}}<span>&nbsp;{{value.unit}}</span>&nbsp;<span>{{value.currency}}</span></span>

          <span class="info_value" v-else >
            <span v-if="name.toLowerCase() == 'revenue'">Pre-Revenue</span>
            <span v-else>No Data</span>
          </span>
          </span>
          <span class="info_value" v-else>No data</span>
      </div>
      <div class="info_startup_2" v-else-if="isDate">
          <span class="info_value" >{{ $filters.formatDateUS(value.date) }}</span>
      </div>
      <div class="info_startup_2" v-else-if="isGrowth">
          <span class="info_value growthLine" v-if="value.m12">12 months: {{value.m12}}%</span>
          <span class="info_value growthLine" v-if="value.m6">6 months: {{value.m6}}%</span>
          <span class="info_value growthLine" v-if="value.m3">3 months: {{value.m3}}%</span>
      </div>
      <div class="info_startup_2" v-else-if="isBoolean">
        <v-badge v-if="value == true"
       color="info"
       content="Yes"
       inline
     ></v-badge>
     <v-badge v-else-if="value == false"
    color="warning"
    content="No"
    inline
  ></v-badge>
  <v-badge v-else
 color="no-info"
 content="Not specified"
 inline
></v-badge>

      </div>
      <div class="info_startup_2 " v-else-if="isUrl">
        <span class="info_value">
          <span v-if="value.length">
             <a class="wordbreak" v-if="displayedAs" :href="getHttpsUrl(value)" target="_blank">{{displayedAs}}</a>
             <a class="wordbreak" v-else :href="getHttpsUrl(value)" target="_blank">{{value}}</a>
           </span>
          <span v-else>No data</span>
        </span>
      </div>
      <div class="info_startup_2" v-else>
          <span class="info_value" v-if="value.name">
            <span v-if="noCutter"> {{value.name}}</span>
            <read-more  v-else more-str="read more" :text="value.name" less-str="read less" :max-chars="50"></read-more>
          </span>
            <span class="info_value" v-else>
              <span v-if="value.length">
                <span v-if="noCutter">{{value}}</span>
                <read-more v-else more-str="read more" :text="value"  less-str="read less" :max-chars="50"></read-more>
              </span>
              <span v-else>
                <span v-if="value">
                  <span v-if="value != 'null'">{{value}}</span>
                  <span v-else>No data</span>
                </span>
                <span v-else>No data</span>
              </span>
            </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name : "StartupInfoLine",
  methods:{
    getHttpsUrl(url){
      var f = url;
      if (!url.startsWith("https://")  && !url.startsWith("htts://") ) {
                  f = "https://" + url;
              }
              return f;
    },
    prettyPrintMoney(moneu,frac){

      if(moneu){
      try {
        var m =0;
        if(typeof moneu == "string") m = moneu.replace(',','.');
        else m = moneu;

        m = parseFloat(m);

        return new Intl.NumberFormat("fr-FR", {
          minimumFractionDigits: 0, // Ensures decimals for small values
          maximumFractionDigits: frac  // Keeps formatting consistent
        }).format(m);
      } catch (e) {
        console.log("Probleme with moneu",moneu);
      }

      }

    }
  },
  props: ["name","value", "color_info","className","displayedAs","isArray","isLocation","isCurrency","isBoolean","isGrowth","isDate","noData","isUrl","noCutter"]
}
</script>

<style lang="css" scoped>

.siline{
  border-bottom: 1px solid #DDD;
}
.info_startup{
  display:flex;
gap: 10px;
/* border-bottom: 1px solid #DDD; */
padding-bottom: 10px;
padding-top: 10px;
}

.noBorder{
  border:none !important;
}

.info_startup_1{
  width: 33%;
}
.info_startup_2{
  width: 66%;
    display:block;
}
.inHeader .info_startup_1{
  width: 25%;
}
.inHeader .info_startup_2{
  width: 75%;
    display:block;
}

.fullW .info_startup_1{
    width: 50%;
  }
.fullW .info_startup_2{
    width: 50%;
      display:block;
}
.info_startup.large_col1 .info_startup_1,
.info_startup.large_col1 .info_startup_2{
  width:50%;
    display:block;
}

@media screen and (max-width: 690px){
  .info_startup{
    flex-direction: column;
  }
  .info_startup_1,
  .info_startup_2{
    width:100%;
      display:block;
  }
}
.info_startup_1 .info_name{
font-size: 12px;
line-height: 15px;
color: #3783C5;
text-transform: uppercase;
font-weight: 700;
}
.info_startup_1 .info_name.innopearl_purple{
  color: #6C68A2;
}
.info_startup_1 .info_name.innopearl_blue{
  color: #3783C5;
}

.info_startup_2 .info_value{
  font-size:16px;
  line-height: 22px;
  white-space: pre-wrap;
}

.startup_founders{
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 0px;
}
.founder{
  font-size: 16px;
  line-height: 28px;
  margin-left:0px;
  padding-left:0px;
}
.founder .picto_link_linkedin{
  margin-left:20px;
}
/* .info_value{
white-space: pre-wrap
} */
.growthLine{
  display:block;
}

.forPDF .info_value,
.forPDF .info_name{

white-space: pre-wrap !important;
word-spacing: 5px !important;
}

.info_startup_2 .info_value a {
    color: #3783C5;
}

.pointmediant{
  background: #B38D2F;
  width: 5px;
  display: inline-block;
  height: 5px;
  border-radius: 50%;
  content: "";
  margin-left: 5px;
  margin-right: 5px;
    transform: translateY(-50%);
}
.info_value a{
  color:inherit !important;
}

.wordbreak{
  word-break: break-all;
}
</style>
<style>
.info_startup_2 .info_value p{
  margin: 0;
  display: contents;
}
.info_startup_2 .info_value #readmore{
  margin-left:5px;
  color:#4c81c0 !important;
}
</style>
